export const defaultRegionCode = 'USA';
export const defaultLang = 'en-US';

export const warnOnMarketChangeTo = ['TWN', 'KOR'];
export const DEFAULT_MAX_NO_OF_UNITS = 9;
